import React from 'react'
import _ from 'lodash'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import classNames from 'classnames'
import ScrollArea from 'react-scrollbar'

import LegContainer from '../leg/leg.container'
import DayGridContainer from '../daygrid/daygrid.container'
import QuickToolsContainer from '../quicktools/quicktools.container'
import QuickCollabsContainer from '../quickcollabs/quickcollabs.container'


const plannerWeekId = 'planner-week-block'
const overflowContainerId = 'planner-overflow'
const maxDaysInView = 8

export class Planner extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            plannerWidth: null,
            quicktools: null,
            quickcollabs: null,
            contentWidth: null,
            scrollDirection: null
        }

        _.bindAll(this,
            'getDayWidth',
            'onShowQuickTools',
            'onHideQuickTools',
            'onShowQuickCollabs',
            'onHideQuickCollabs',
            'updateScrollElement',
            'onAppendDay',
            'onPrependDay'
        )
    }

    componentDidMount() {
        this.updatePlannerWidth()
        window.addEventListener('resize', _.debounce(() => {
            this.updatePlannerWidth()
        }, 250))
        this.updateScrollElement()
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.totalDays !== prevProps.totalDays || this.state.plannerWidth !== prevState.plannerWidth) {
            this.updateScrollElement()
        }
    }

    updateScrollElement() {
        let _this = this
        window.requestAnimationFrame(function () {
            let node = _this.refs.plannerScrollArea
            if (node !== undefined) {
                let dayWidth = _this.getDayWidth()
                let overflowWidth = dayWidth * _this.props.totalDays
                node.content.style.width = overflowWidth + 'px'
                node.scrollArea.refresh()
                if (_this.state.scrollDirection == 'left') {
                    node.scrollArea.scrollLeft()
                    _this.setState({scrollDirection: null})
                } else if (_this.state.scrollDirection == 'right') {
                    node.scrollArea.scrollRight()
                    _this.setState({scrollDirection: null})
                }
            }
        })
    }

    updatePlannerWidth() {
        let weekPlanner = document.getElementById(plannerWeekId)
        let plannerWidth = weekPlanner.getBoundingClientRect().width
        this.setState({plannerWidth: plannerWidth})
    }

    onShowQuickTools(leg, x, y) {
        this.setState({
            quicktools: {
                leg: leg,
                x: x,
                y: y,
                onHideQuickTools: this.onHideQuickTools,
            }
        })
    }

    onHideQuickTools() {
        if (this.state.quicktools !== null) {
            this.setState({
                quicktools: null
            })
        }
    }

    renderQuickTools() {
        if (_.isNull(this.state.quicktools)) {
            return null
        }

        return (
            <QuickToolsContainer {...this.state.quicktools}/>
        )
    }

    onShowQuickCollabs(leg, x, y, users) {
        this.setState({
            quickcollabs: {
                leg: leg,
                x: x,
                y: y,
                users: users,
                onHideQuickCollabs: this.onHideQuickCollabs,
            }
        })
    }

    onHideQuickCollabs() {
        this.setState({
            quickcollabs: null
        })
    }

    onPrependDay() {
        this.setState({scrollDirection: 'left'})
        this.props.onPrependDay()
    }

    onAppendDay() {
        this.setState({scrollDirection: 'right'})
        this.props.onAppendDay()
    }

    renderQuickCollabs() {
        if (_.isNull(this.state.quickcollabs)) {
            return null
        }

        return (
            <QuickCollabsContainer {...this.state.quickcollabs}/>
        )
    }

    getDayWidth() {
        let minimumDayWidth = this.state.plannerWidth / maxDaysInView
        let dayWidth = _.max(
            [minimumDayWidth, this.state.plannerWidth / this.props.totalDays]
        )
        return dayWidth
    }

    renderTrip() {
        if (_.isNull(this.state.plannerWidth)) {
            return null
        }

        let dayWidth = this.getDayWidth()
        let overflowWidth = dayWidth * this.props.totalDays

        return (
            <div id="overflow-block" className="overflow-container" style={{width: overflowWidth}}>
                <DayGridContainer dayWidth={dayWidth}/>
                <LegContainer
                    width={overflowWidth}
                    quicktoolsEvents={{show: this.onShowQuickTools, hide: this.onHideQuickTools}}
                    quickcollabsEvents={{show: this.onShowQuickCollabs, hide: this.onHideQuickCollabs}}/>
            </div>
        )
    }

    render() {
        let updateArrivalDate = (evt) => {
            let newArrivalDate = evt ? moment(evt) : null
            let arrivalDateAfterDepartureDate = moment(newArrivalDate).isAfter(this.props.departureDate)
            if (arrivalDateAfterDepartureDate) {
                alert('Arrival date cannot be after departure date.')
                return null
            }
            let arrivalDateIsInPast = moment(newArrivalDate).isBefore(moment())
            if (arrivalDateIsInPast) {
                alert('Arrival date cannot be in the past.')
                return null
            }

            this.props.onUpdateArrivalDate(newArrivalDate, this.props.departureDate, this.props.totalDays, this.props.legs)
        }

        let updateDepartureDate = (evt) => {
            let newDepartureDate = evt ? moment(evt) : null
            let notValid = moment(newDepartureDate).isBefore(this.props.arrivalDate)
            if (notValid) {
                alert('Departure date cannot be before arrival date.')
                return null
            }

            this.props.onUpdateDepartureDate(newDepartureDate, this.props.arrivalDate, this.props.totalDays, this.props.legs)
        }

        let plannerClassNames = classNames(
            'planner-band',
            'container-fluid',
            {'has-arrival-date': !!this.props.arrivalDate}
        )

        return (
            <div id="planner-band" className={plannerClassNames}>

                {this.renderQuickTools()}
                {this.renderQuickCollabs()}

                <div id="planner-band-top" className="row">
                    <div className="col-sm-4 arrival-datepicker">
                        <DatePicker
                            placeholderText="ADD ARRIVAL"
                            selected={this.props.arrivalDate}
                            onChange={updateArrivalDate}
                            dateFormat='MMMM D, YYYY'
                            className='btn btn-plain'
                            isClearable={false}/>
                        {/* this.props.arrivalDate ? (<label>Arrival</label>) : null*/}
                    </div>
                    <div className="col-sm-4">
                        <div className="planner-icons">
                            <i className="icon-view_leg"/>
                            <i className="icon-view_calendar"/>
                            <i className="icon-view_destination"/>
                            <i className="icon-view_map"/>
                        </div>
                    </div>
                    <div className="col-sm-4 departure-datepicker">
                        {/* this.props.departureDate ? (<label>Departure</label>) : null*/}
                        <DatePicker
                            placeholderText="ADD DEPARTURE"
                            selected={this.props.departureDate}
                            onChange={updateDepartureDate}
                            dateFormat='MMMM D, YYYY'
                            className='btn btn-plain'
                            isClearable={false}/>
                    </div>
                </div>
                <div id="planner-band-lower">
                    <div className="planner-row">
                        <div className="add-day-wrapper">
                            <div className="add-day" onClick={this.onPrependDay}>
                                <i className="icon-plus" aria-hidden="true"/>
                            </div>
                        </div>
                        <div id={plannerWeekId}>
                            <ScrollArea
                                ref="plannerScrollArea"
                                speed={0.8}
                                className="area"
                                contentClassName="planner-scroll-content"
                                horizontal={true}
                                onScroll={() => {
                                    this.onHideQuickTools()
                                }
                                }>
                                {this.renderTrip()}
                            </ScrollArea>
                        </div>
                        <div className="add-day-wrapper">
                            <div className="add-day" onClick={this.onAppendDay}>
                                <i className="icon-plus" aria-hidden="true"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
